module.exports = __webpack_public_path__ + "assets/img/logo.fda78fbf.png";